var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpoint } from '@airtel/air-design-system';
import { merge } from 'lodash';
var getBreakpointProps = function getBreakpointProps(breakpointProps, currentBreakpoint) {
  if (breakpointProps === void 0) {
    breakpointProps = {};
  }
  var breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'];
  var currBreakpointIndex = breakpoints.indexOf(currentBreakpoint);
  return breakpoints.slice(0, currBreakpointIndex + 1).reduce((prev, curr) => Object.assign(Object.assign({}, prev), breakpointProps[curr]), {});
};
export var withBreakpoint = Component => {
  var Wrapper = props => {
    var _props$withBreakpoint = props.withBreakpoint,
      withBreakpoint = _props$withBreakpoint === void 0 ? false : _props$withBreakpoint,
      _props$withBreakpoint2 = props.withBreakpointProps,
      withBreakpointProps = _props$withBreakpoint2 === void 0 ? {} : _props$withBreakpoint2,
      restProps = __rest(props, ["withBreakpoint", "withBreakpointProps"]);
    var currentBreakpoint = useBreakpoint();
    var _withBreakpointProps$ = withBreakpointProps.shouldDeepMerge,
      shouldDeepMerge = _withBreakpointProps$ === void 0 ? false : _withBreakpointProps$;
    if (withBreakpoint && shouldDeepMerge) {
      var currentBreakpointProps = withBreakpointProps[currentBreakpoint] || {};
      var mergedProps = merge({}, restProps, currentBreakpointProps);
      return _jsx(Component, Object.assign({}, mergedProps));
    }
    if (withBreakpoint) {
      var widgetProps = Object.assign(Object.assign({}, restProps), getBreakpointProps(withBreakpointProps, currentBreakpoint));
      return _jsx(Component, Object.assign({}, widgetProps));
    } else {
      return _jsx(Component, Object.assign({}, restProps));
    }
  };
  return Wrapper;
};